import React from 'react';
import { Link } from 'gatsby';
import Image from '../../common/Image';
import logo from '../../../img/logo.svg';

var Logo = function Logo() {
  return /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement(Image, {
    src: logo,
    alt: "LRA"
  }));
};

export default Logo;